<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class="flex md9 sm6 xs12">
            <va-button flat>
              角色:
            </va-button>
            <va-button flat color="danger" v-for="role in insertData.roles" :key="role">
              {{role}}
            </va-button>
          </div>
          <div class="flex md3 sm6 xs12">
            <div class="d-flex justify--end">
              <va-button  color="warning" outline  small  icon="fa fa-pencil" @click="showSubmitButton=true">
                编辑个人资料
              </va-button>
            </div>
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="员工创建时间"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nickname"
              label="员工姓名"
              :disabled="!showSubmitButton"
              :messages="showSubmitButton ? message : []"
              :error="!!error.nicknameErrors.length"
              :error-messages="error.nicknameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.email"
              label="邮箱"
              :disabled="!showSubmitButton"
              :messages="showSubmitButton ? message : []"
              :error="!!error.emailErrors.length"
              :error-messages="error.emailErrors"
            />
          </div>

          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.libaUid"
              label="篱笆帮小程序用户uid"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12 justify--end" v-show="showSubmitButton">
            <div class="d-flex justify--end">
              <va-button class="mb-2" outline color="info" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
                保存
              </va-button>
            </div>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-button class="mb-2" outline color="gray" slot="trigger" @click="$router.push({ name: 'listEmployee'})" :disabled="!submitButtonStatus">
              返回
            </va-button>
          </div>
        </div>

      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime } from '@/utils/common'
import employeeApi from '../../api/employee'
import roleApi from '../../api/role'

export default {
  data () {
    return {
      insertData: {
        id: null,
        nickname: '',
        email: '',
        libaUid: null,
        createTime: '',
        roles: [],
      },
      message: ['Required field'],
      error: {
        nicknameErrors: [],
        emailErrors: [],
      },
      showId: false,
      title: '个人中心',
      submitButtonStatus: true,
      showSubmitButton: false,
    }
  },
  created () {
    if (localStorage.getItem('employeeId') == null || localStorage.getItem('employeeId') !== this.$route.params.id) {
      this.$router.push('/dashboard')
    }
    this.getEmployee()
    this.listEmployeeRole()
  },
  computed: {
    formReady () {
      return !this.error.nicknameErrors.length &&
          !this.error.emailErrors.length
    },
  },
  methods: {
    getEmployee () {
      const employeeId = localStorage.getItem('employeeId')
      if (employeeId != null) {
        this.showId = true
        // 通过id获取详情
        employeeApi.getEmployee(employeeId).then(response => {
          copyObject(response.employee, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    listEmployeeRole () {
      employeeApi.listEmployeeRoles(localStorage.getItem('employeeId')).then(response => {
        response.roles.map(x => {
          this.insertData.roles.push(x.displayName)
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        nickname: this.insertData.nickname,
        email: this.insertData.email,
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        employeeApi.updateEmployee(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('更新员工成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.getEmployee()
            this.changeButtonStatus(true)
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        employeeApi.createEmployee(data).then(response => {
          if (response.success === true) {
            this.showToast('添加员工成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listEmployee' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nicknameErrors = this.insertData.nickname ? [] : ['nickname is required']
      this.error.emailErrors = this.insertData.email ? [] : ['email is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
